import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AiAssistedSearchBanner } from '@thd-olt-component-react/ai-assisted-search-banner';

export const AI_ASSISTED_SEARCH_BANNER = 'aiAssistedSearchBanner';

export const IN_GRID_COMPONENT_REGISTRY = {
  [AI_ASSISTED_SEARCH_BANNER]: () => (
    <ErrorBoundary name="ai-assisted-search-banner">
      <QueryProvider cacheKey="ai-assisted-search-banner">
        <AiAssistedSearchBanner />
      </QueryProvider>
    </ErrorBoundary>
  )
};
